import React from 'react';
import {
	SypacVerticalTimeline,
	SypacVerticalTimelineStep,
} from '@sypac/component-library-react';

import AssignedTo from '../../../components/Notification/AssignedTo';
import { useTranslate } from '@tolgee/react';

interface NotificationAssignedToProps {
	notification: boolean;
	date: string;
	avatar: string;
	username: string;
}

const NotificationAssignedTo = ({
	notification,
	date,
	avatar,
	username,
}: NotificationAssignedToProps) => {
	const { t } = useTranslate();

	return (
		<div className="flex flex-row gap-[25px]">
			<SypacVerticalTimeline>
				<SypacVerticalTimelineStep
					isActive={notification}
					isFinalStep={true}
					minWidth={247}
				>
					{date}
				</SypacVerticalTimelineStep>
			</SypacVerticalTimeline>
			<div className="h-fit w-full">
				<AssignedTo
					notification={notification}
					title={t(
						'adminAssignedTo.orderHasBeenAssignedTo',
						'The order has been assigned to:',
					)}
					description={t(
						'adminAssignedTo.confirmPickupDetails',
						'Confirm pick-up details.',
					)}
					avatar={avatar}
					username={username}
				/>
			</div>
		</div>
	);
};

export default NotificationAssignedTo;
